import styled from 'styled-components';
import _ActionButton from "./_ActionButton";


const MainJoinButton = styled(_ActionButton)`
    //&:hover {
    //  background-color: lightseagreen;
    //}
`;


export default MainJoinButton


// WEBPACK FOOTER //
// ./src/components/CustomerActions/ContactButton.js